/// <reference path='../_all.ts' />

module solution {
  'use strict';

  export class SolutionData {
    constructor(
      public Current: IRouteEntry,
      public Previous: IRouteEntry,
      public Next : IRouteEntry,
      public MeasuringTaskGroups: MeasuringTaskGroup[],
      public Meta : IPageMeta,
      public Intro: Intro,
      public Schema: string,
      public MeasuringTasks: MeasuringTask[],
      public Products: Product[],
      public IsIndustry: boolean
      ) { }
  }
}

